export const SHARE_WIN = 'share'
export const RESERVE_WIN = 'reserve'
export const REFI_WIN = 'refi'
export const HOME_INSURANCE_WIN = 'home_insurance'
export const ESS_WIN = 'equity_smart_search'
export const NEW_HOME_WIN = 'new_home'
export const SHOULD_YOU_SELL_WIN = 'should_you_sell'
